import React, { Component } from 'react'
import Img from 'gatsby-image'
import styled from 'styled-components'
import Slider from './Slider'
import MenuLink from './MenuLink'
import { CommerceButton } from './Buttons'

const Wrapper = styled.section`
  position: relative;
  min-height: ${props => props.size === 'Large' ? '600px' : '300px'};
  margin-bottom: 2.5rem;
`
const BgImg = styled(Img)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: -1;
  min-height: ${props => props.size === 'Large' ? '600px' : '300px'};
  height: ${props => props.size === 'Large' ? '600px' : '300px'};
  @media (min-width: ${props => props.theme.responsive.small}) {
    height: ${props => props.height || '300px'};
  }
  & > img {
    object-fit: ${props => props.fit || 'cover'} !important;
    object-position: ${props => props.position || '50% 50%'} !important;
  }
  &::before {
    content: '';
    background: ${props => props.size === 'Large' ? 'none' : 'rgba(0, 0, 0, 0.25)'};
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
  }
`

const Title = styled.h1`
  font-size: ${props => props.size === 'Large' ? '4rem' : '3rem'};
  @media (max-width: ${props => props.theme.responsive.small}) {
      font-size: 3rem;
  }
  line-height: ${props => props.size === 'Large' ? '100%' : 'normal'};
  text-transform: capitalize;
  font-weight: 800;
  position: absolute;
  width: 100%;
  max-width: ${props => props.theme.sizes.maxWidthCentered};
  padding: 0 1rem;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: ${props => props.size === 'Large' ? props.theme.colors.brandDarkSecondary : 'white'};
`
const ButtonContainer = styled.div`
  position: absolute;
  width: 100%;
  max-width: ${props => props.theme.sizes.maxWidthCentered};
  padding: 0 1rem;
  top: 65%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
`

export default class Hero extends Component {
  render() {
    // Deconstruct data from props
    const { data } = this.props
    // if data does not exist then return null to avoid errors
    if (!data) return null
    // console.log('hero data: ', data);

    // deconstruct out the contentful data attributes and objects
    const {
      image,
      title,
      slideshow,
      size,
      buttonLink,
    } = data

    if(slideshow) {
      return <Slider data={slideshow}/>
    }

    return (
      <Wrapper size={size}>
        { image ?
        <BgImg
          size={size}
          fluid={image.fluid}
          backgroundColor={'#eeeeee'}
        /> : null }
        <Title dangerouslySetInnerHTML={{ __html: title }} size={size} />
        { buttonLink ?
          <ButtonContainer>
            <CommerceButton>
              <MenuLink link={buttonLink} />
            </CommerceButton>
          </ButtonContainer>
          : null
        }
      </Wrapper>
    )
  }
}
